
import './App.css';
import BollywoodMovies from './components/BollywoodMovies';

function App() {
  return (
    <div className="App">
      
      <BollywoodMovies />
      
    </div>
  );
}



export default App;
